module.exports = __webpack_public_path__ + "static/media/callIconService.3f5c84d2.svg";